@if (badges.error()) {
  <ideal-error [error]="badges.error()"></ideal-error>
} @else {
  <!-- <ideal-loading-container [loading]="!ready()"> -->
  <div badges>
    @for (item of badgeItems(); track $index) {
      <ideal-image badge [src]="item.imageUrl" [alt]="item.title"></ideal-image>
    }
  </div>
  <!-- </ideal-loading-container> -->
}
